import { fetchBasicJsonPostJson, fetchUrlGet } from '@/script/common';

export default {
	getSelectData: (page, itemsPerPage, filter, signal) => {
		var parameters = {
			page: page,
			pageSize: itemsPerPage
		};
		if (filter.search) {
			if (/^\d{11}$/.test(filter.search)) {
				parameters.patient_personal_number = filter.search;
			} else {
				parameters.history_number = filter.search;
			}
		}
		return fetchBasicJsonPostJson(
			'/History/GetDataTableData',
			{ data: parameters, signal: signal },
			{ useBlock: !signal }
		);
	},
	getData: (page, pageSize, filter) => fetchBasicJsonPostJson('/History/GetData', { data: { page, pageSize, ...filter } }),
	getFirstSurgery: historyCode => fetchUrlGet('/Surgery/FirstSurgeryOfHistory', { data: { historyCode: historyCode } }),
	setHistoryLayingStatus: (code, layingStatus) => fetchBasicJsonPostJson('/History/SetLayingStatus', { data: { code, layingStatus } }, { commonResponse: true }),
};
